import { Mic, Sparkles, Lock } from "lucide-react";

const CoreServicesSection = () => {
  const services = [
    {
      icon: Mic,
      title: "Real-Time Medical Scribing",
      description: "Live or post-encounter documentation support. Our trained scribes capture every detail so you can focus on your patients.",
      features: ["Live documentation", "Post-encounter support", "EHR integration"],
    },
    {
      icon: Sparkles,
      title: "AI-Enhanced Editing",
      description: "Advanced AI refinement ensures accuracy, clarity, and consistency across all your medical documentation.",
      features: ["Error detection", "Terminology standardization", "Format consistency"],
    },
    {
      icon: Lock,
      title: "HIPAA-Compliant Transcription",
      description: "Secure handling of all patient data with enterprise-grade encryption and strict compliance protocols.",
      features: ["256-bit encryption", "Audit trails", "Access controls"],
    },
  ];

  return (
    <section 
      id="services"
      data-testid="core-services-section"
      className="py-16 sm:py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-xs sm:text-sm font-medium uppercase tracking-widest text-cyan-500 mb-3 sm:mb-4 block">
            What We Offer
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
            Core Services
          </h2>
          <p className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto px-4">
            Comprehensive documentation solutions designed for modern healthcare
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="glass-card p-6 sm:p-8 md:p-10 card-hover-lift group relative overflow-hidden"
            >
              {/* Glow effect on hover */}
              <div className="absolute inset-0 bg-gradient-to-b from-cyan-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <div className="relative">
                <div className="w-12 h-12 sm:w-14 sm:h-14 mb-4 sm:mb-6 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors">
                  <service.icon className="w-6 h-6 sm:w-7 sm:h-7 text-cyan-400" />
                </div>
                
                <h3 className="text-lg sm:text-xl font-semibold text-white mb-3 sm:mb-4">{service.title}</h3>
                <p className="text-slate-400 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">{service.description}</p>
                
                <ul className="space-y-2">
                  {service.features.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-center gap-2 text-xs sm:text-sm text-slate-500">
                      <div className="w-1.5 h-1.5 rounded-full bg-cyan-500" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreServicesSection;
